import React, { Component, PropTypes } from 'react';
import Login from "./Login";
import Registration from "./Registration";
class Auth extends Component {
    
    constructor(props) {
      super(props);
    }
    componentDidMount() {
      document.querySelector('body').classList.add('login_page');
    }
    render() {
      return (
            <div> 
             {
               (window.location.href.includes('registration') == true) ? 
               <Registration />
               
               : <Login />
             }
              
            </div>
      );
    }
}

export default Auth;